module.exports = __webpack_public_path__ + "static/media/movieme1.adfdabc4.png";